<template>
  <table class="datatable md:bg-white">
    <thead class="hidden md:table-header-group">
      <tr>
        <th
          scope="col"
          v-for="column in columns"
          :key="column.name"
          :style="'width:' + column.width + ';'"
        >
          <div class="flex items-center justify-center">
            <div class="w-90p">{{ column.label }}</div>
            <div class="w-10p">
              <i
                class="mdi text-xl"
                v-if="column.sortable"
                @click="$emit('sort', column.name)"
                :style="'cursor:pointer;'"
                :class="{
                  'mdi-chevron-down': sortOrders[column.name] <= 0,
                  'mdi-chevron-up': sortOrders[column.name] === 1,
                  'text-gray-400': sortOrders[column.name] === 0
                }"
              ></i>
            </div>
          </div>
        </th>
        <th scope="col">
          <span class="sr-only">Actions</span>
        </th>
      </tr>
    </thead>
    <slot />
  </table>
</template>

<script>
export default {
  props: ["columns", "sortKey", "sortOrders"]
};
</script>
